import { DEFAULT_BACKGROUND } from "@faro-lotv/app-component-toolbox";
import { grey, useIsDarkScheme } from "@faro-lotv/flat-ui";
import { Color, LinearSRGBColorSpace } from "three";

/**
 * Background of the 3D/2D canvas in dark mode.
 * Created before the canvas disables color management, so the sRGB to linear conversion is skipped explicitly.
 */
export const DARK_CANVAS_BACKGROUND = new Color().setStyle(
  grey[1200],
  LinearSRGBColorSpace,
);

/** @returns The canvas background for the active color scheme. Shared instance, must not be mutated. */
export function useCanvasBackground(): Color {
  return useIsDarkScheme() ? DARK_CANVAS_BACKGROUND : DEFAULT_BACKGROUND;
}
